"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Paper_1 = __importDefault(require("@mui/material/Paper"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Grid_1 = __importDefault(require("@mui/material/Grid"));
var IconLabel_1 = __importDefault(require("../icon-label/IconLabel"));
require("../../scss/_label-icon-card.scss");
/**
 * @component LabelIconCard
 * @example
 * return (
 * <LabelIconCard
 *    content={'some text or component'}
 *    icon={<AttachMoneyIcon />}
 *    label="some label goes here"
 *    showIconBackground={false}
 *  />)
 *
 * @param {Component} icon pass a MUI icon here
 * @param {string} label label to display next to the icon
 * @param {boolean} isBold is the text bold?
 * @param {string} content accepts child components
 * @param {boolean} showIconBackground show a gray circle background on the icon
 */
var LabelIconCard = function (props) {
    var icon = props.icon, label = props.label, isBold = props.isBold, content = props.content, showIconBackground = props.showIconBackground;
    return (react_1.default.createElement(Paper_1.default, { className: 'px-2 py-2' },
        react_1.default.createElement(Grid_1.default, { container: true },
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(Box_1.default, { className: 'top-text-style' },
                    react_1.default.createElement(IconLabel_1.default, { icon: icon, label: label, isBold: isBold, showIconBackground: showIconBackground })))),
        react_1.default.createElement(Grid_1.default, { className: 'mb-8', container: true, justifyContent: "center", alignContent: "center" },
            react_1.default.createElement(Grid_1.default, { item: true, xs: 12 },
                react_1.default.createElement(Typography_1.default, { variant: "h1" },
                    react_1.default.createElement(Box_1.default, { className: 'content-text-styles', fontWeight: "fontWeightBold" }, content))))));
};
exports.default = LabelIconCard;
